module.exports = __webpack_public_path__ + "media/icons/key-4-3474acb3.svg";